const parts = [
  '^arn',
  ':',
  '(?<partition>.+?)?',
  ':',
  '(?<service>.+?)?',
  ':',
  '(?<region>(.+?))?',
  ':',
  '(?<accountId>(\\d{12}|aws))?',
  ':',
  '(?<resource>(.+?))?',
  '($|/|:(/\\S\+?){2}/|:)', // middle :(/\\S\+?){2}/ regex outs trailing /aws/lambda on log-groups
  '(?<instance>(.+?))?',
  '($|/|:)',
  '(?<suffix1>(.+?))?',
  '($|/|:)',
  '(?<suffix2>(.+?))?',
  '($|/|:)',
  '(?<suffix3>(.+?))?',
  '$',
]

export type ArnParts = {
  partition: string | undefined
  service: string | undefined
  region: string | undefined
  accountId: string | undefined
  resource: string | undefined
  instance: string | undefined
  suffix1: string | undefined
  suffix2: string | undefined
  suffix3: string | undefined
}

export type ArnRegexResult = ArnParts | undefined

export const arnRegex = parts.join('')

export const getArnParts = (arn: string): ArnRegexResult => new RegExp(arnRegex).exec(arn)?.groups as ArnRegexResult
